export default "/_next/static/media/Yemen coffee.c6058e89d8537ccc9c03db9f2074d9b7.jpeg";